export default state => state.auth.loggedIn;
